import { generateClassName } from "@smoothincorg/smooth-ui"
import styled from "styled-components"

type Props = JSX.IntrinsicElements["div"] & {
  maxWidth?: number
}

const { getRootClassName } = generateClassName("Wrapper")

const Component: React.FC<Props> = (props) => {
  return <div className={getRootClassName(props)}>{props.children}</div>
}

const StyledComponent = styled(Component)`
  margin: 0 auto;
  width: 90%;
  max-width: ${(props) => props.maxWidth || 1000}px;
`

export const Wrapper = StyledComponent
